
export const pumpedgabo = {
  content: {
    allRightsReserved: "All rights reserved.",
    loading: "Loading...",
    notFound: "The requested content was not found.",
    backToList: "Back to content list",
    readyToStart: "Ready to start?",
    purchaseDescription: "Purchase this content now and get immediate access to all materials.",
    purchaseNow: "Buy now",
    detailedDescription: "Detailed description",
    whatIncludes: "What's included",
    features: "Features",
    buy: "Buy",
    package: {
      title: "Exclusive Pumped Gabo packages",
      description: "Choose from my specially curated content packages"
    },
    personalMeeting: {
      title: "Personal meeting with Pumped Gabo",
      subtitle: "Individual training and mentoring",
      description: "Experience a transformative personal meeting where I share my fitness expertise and zen philosophy directly with you."
    }
  },
  chat: {
    sendMessage: "Send your message",
    price: "One message costs: {price} HUF",
    rules: "Rules",
    ruleRespect: "Please write respectfully",
    ruleSpam: "Avoid spam-like messages",
    ruleLength: "Message can be maximum {maxLength} characters long",
    ruleResponse: "I'll respond within {days} days",
    message: "Message",
    messagePlaceholder: "Write your question here...",
    characters: "characters",
    proceedToPayment: "Proceed to payment ({price} HUF)",
    errorEmptyMessage: "Please enter your message",
    errorTooLong: "Message cannot be longer than {maxLength} characters"
  },
  media: {
    title: "Media appearances",
    viewArticle: "View"
  },
  workshop: {
    title: "Zen Workshops with Pumped Gabo",
    subtitle: "Discover inner harmony",
    description: "Exclusive workshops where bodybuilding and zen philosophy meet",
    benefits: "Benefits",
    includes: "What's included",
    relatedWorkshops: "More workshops",
    register: "Register for the workshop",
    bookingPolicy: "By registering, you accept the terms and conditions for the workshop",
    filterAll: "All",
    filterBeginner: "Beginner",
    filterIntermediate: "Intermediate",
    filterAdvanced: "Advanced",
    searchPlaceholder: "Search workshops...",
    notFound: "No workshops match your search criteria",
    showAllButton: "View all workshops",
    faq: {
      title: "Frequently Asked Questions",
      equipment: {
        question: "What equipment should I bring to the workshop?",
        answer: "Just comfortable clothes and maybe a yoga mat or sitting cushion. We provide all other necessary tools. If you have a favorite meditation tool, you're welcome to bring it."
      },
      experience: {
        question: "Do I need prior experience to participate?",
        answer: "No prior experience is necessary. Our workshops are available at all levels, from complete beginners to experienced practitioners. Everyone can adjust the exercises to their own level."
      },
      refund: {
        question: "Can I cancel my booking if I can't attend?",
        answer: "Yes, we offer full refunds up to 72 hours before the workshop. After that, we can refund 50% of the paid amount. For cancellations within 24 hours, unfortunately we cannot provide refunds."
      },
      preparation: {
        question: "How should I prepare for the workshop?",
        answer: "It's best to go to bed early the night before and arrive well-rested. Don't eat heavy meals 2 hours before the workshop, and after booking, we'll send some short reading materials that are worth reviewing in advance."
      }
    }
  },
  services: {
    workoutPlans: {
      title: "Workout Plans",
      description: "Personalized and general workout plans where I share my bodybuilding pope experiences, effective exercises and tips for physical development."
    },
    thoughtDiscussion: {
      title: "Thought-provoking Discussion",
      description: "Share your thoughts and questions about healthy lifestyle, music or sustainability with me. I'm happy to share my own experiences with you."
    },
    personalVideo: {
      title: "Personal Video Message",
      description: "In a personalized video message, I can share my motivational thoughts with you or convey a special message to someone important to you."
    },
    communityMeetings: {
      title: "Community Meetings",
      description: "Virtual meetings where we can explore the paths of exercise, self-development, zen philosophy and environmental awareness together, sharing our experiences with each other."
    },
    personalMeeting: {
      title: "Personal Meeting",
      description: "A special occasion when you can meet me in person, whether for training, DJ performance or nature retreat. A unique experience where you can connect with me directly."
    },
    personalCoaching: {
      title: "Personal Coaching",
      description: "Individual conversation and training with me in person. Sharing my experiences and perspective that helps you find balance between body, mind and environmentally conscious lifestyle."
    },
    experiencePackages: {
      title: "Experience Packages",
      description: "Through connected experiences, you can discover different aspects of bodybuilding, zen philosophy and eco-conscious lifestyle, all in one place."
    }
  }
};
